/**
 * `SPARK/Rail`: "Distance-from-leader bar." A rank row's rail fill is its OWN score over the board's
 * LEADER's score -- never over the row immediately above it. With a descending board every row's
 * score falls monotonically, so "over the leader" and "over the row above" only diverge once you
 * compare a row against something other than its immediate neighbour, which is exactly why this is
 * its own named, tested function rather than an inline expression a mutation could silently swap.
 *
 * @param score - this row's own total score.
 * @param leaderScore - the board's #1 score for the same board/period.
 * @returns the fill percentage (0-100), or `0` when there is no leader score to compare against
 *   (an empty board), rather than dividing by zero.
 */
export const railFillPercent = (score: number, leaderScore: number): number => {
  if (leaderScore <= 0) return 0;
  return Math.min(100, Math.max(0, (score / leaderScore) * 100));
};
